import type { RequestDateMode, RequestShowDateDTO } from "../../contracts/requests";
import { toDateTimeLocalValue } from "@/shared/lib/datetime-local-form";

export function resolveRequestDateFields(input: {
  dateMode?: RequestDateMode;
  requestedEventDate?: string | null;
  showDates?: string[];
}): {
  dateMode: RequestDateMode;
  requestedEventDate: Date | null;
  showDatesToSave: string[] | null;
} {
  const dateMode = input.dateMode ?? "event_date";

  if (dateMode === "show_dates") {
    const showDatesToSave = (input.showDates ?? [])
      .map((value) => value.trim())
      .filter(Boolean);
    const parsed = showDatesToSave.map((value) => new Date(value));
    return {
      dateMode,
      requestedEventDate: minDate(parsed),
      showDatesToSave,
    };
  }

  return {
    dateMode,
    requestedEventDate: input.requestedEventDate
      ? new Date(input.requestedEventDate)
      : null,
    showDatesToSave: null,
  };
}

function minDate(dates: Date[]): Date | null {
  if (dates.length === 0) return null;
  return dates.reduce((min, date) =>
    date.getTime() < min.getTime() ? date : min,
  );
}

export function buildRequestEventDatePrefill(input: {
  dateMode: RequestDateMode;
  requestedEventDate: Date | string | null | undefined;
  showDates?: RequestShowDateDTO[];
}): { eventDate: string; endDate: string | null } {
  const showDates = input.showDates ?? [];
  if (input.dateMode === "show_dates" && showDates.length > 0) {
    const sorted = [...showDates].sort(
      (a, b) => new Date(a.showDate).getTime() - new Date(b.showDate).getTime(),
    );
    const first = new Date(sorted[0]!.showDate);
    const last = new Date(sorted[sorted.length - 1]!.showDate);
    return {
      eventDate: toDateTimeLocalValue(first) || "",
      endDate:
        sorted.length > 1 && last.getTime() !== first.getTime()
          ? toDateTimeLocalValue(last) || null
          : null,
    };
  }

  return {
    eventDate: toDateTimeLocalValue(input.requestedEventDate) || "",
    endDate: null,
  };
}
